import Input from '@blocks/Input'
import React, { useState } from 'react'
import { useTableContext } from '../context'

const RowsPerPage = () => {
    const { state, setPageSize, options } = useTableContext()

    const [inputWidth, setInputWidth] = useState<string>(state.pageSize.toString().length + "ch")

    return (
        <Input
            id="rows-per-page" 
            name="rows-per-page"
            type="number" 
            format="ch"
            label="Rows per page:"
            value={state.pageSize} 
            style={{ width: inputWidth }}
            inline
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const newValue = parseInt(e.target.value)
                const number = newValue > 0 ? newValue : 1
                setPageSize(number)
                setInputWidth(number.toString().length + "ch")

                if (options?.listeners?.onRowsPerPageChange)
                    options.listeners.onRowsPerPageChange(number)
            }}
        />
    )
}

export default React.memo(RowsPerPage)